import { Feature, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import { reaction } from 'mobx';

/**
 * 适用于数据不落盘，且有多个入口需要同步是否为check状态的feature
 */
@Feature()
export class BaseCheckFeature extends BaseToolbarFeature {
    /**
     * 按钮是否勾选
     */
    protected buttonChecked: boolean;
    public constructor(protected readonly toolbarService: ToolbarService) {
        super();
        this.init();
    }

    /**
     * 存储的数据：是否展示
     */
    protected isDisplayed() {
        return false;
    }

    protected loadAsync(): Promise<any> {
        return Promise.resolve();
    }

    private async init() {
        // 监听的变量可能是异步加载的
        await this.loadAsync();
        this.buttonChecked = this.isDisplayed();
        // 监听由其他入口触发的变更
        reaction(
            () => this.isDisplayed(),
            (isDisplayed) => {
                if (this.buttonChecked !== isDisplayed) {
                    this.buttonChecked = isDisplayed;
                    this.toolbarService.$forceUpdate();
                }
            },
        );
    }
}
